import { getTokenUrl } from '@components/shared/RenderTokenIcon'
import commonPoolStore from '@store/commonPoolStore'
import Image from 'next/image'
import { cn } from 'utils/classnames'

interface Props {
  heading: string
  iconSize: number
  className?: string
}

const VaultHeader = ({ heading, iconSize, className }: Props) => {
  const selectedVault = commonPoolStore((store) => store.selectedVault)
  const commonPoolAsset = selectedVault?.label

  return (
    <div className={cn('flex items-center px-4 py-2', className)}>
      <div className="flex items-center gap-2">
        <Image
          alt="rfx vault logo"
          src={getTokenUrl(commonPoolAsset?.toLowerCase(), 'active')}
          width={iconSize}
          height={iconSize}
        />

        <div className="flex flex-col">
          <span className="text-sm font-semibold text-th-fgd-1">{heading}</span>
        </div>
      </div>
    </div>
  )
}

export default VaultHeader
